(function($) {
	$.fn.userdetails = function() {
		return this.each(function() {
			var $this = $(this);
            $this.tooltip({
                items: "*",
                position: { my: "left top+5", at: "left bottom", collision: "flipfit" },
                content: function() {
                    return $this.data('user-details');
                },
                open: function( event, ui ) {
                    ui.tooltip.find('.thumbnail img').imageLoader();
                }
            });
        });
	};
})(jQuery);